const copyArray = <T>(array: T[]): T[] => JSON.parse(JSON.stringify(array));

export default copyArray;